import styled, { css } from 'styled-components'
import { themeColor, themeFontFamily } from 'LibNeo'
import { Badge } from 'antd'

const BadgeWhite = css`
	.ant-badge-count {
		box-shadow: 0 0 0 1px ${themeColor('gray', 3)};
		background-color: ${themeColor('white')};
		color: ${themeColor('gray', 5)};
	}
`
const BadgePrimary = css`
	.ant-badge-count {
		background-color: ${themeColor('emerald', 5)};
	}
`
const BadgeDanger = css`
	.ant-badge-count {
		background-color: ${themeColor('pink', 5)};
	}
`
export const BadgeContainer = styled(Badge)<{
	type?: string
}>`
	font-family: ${themeFontFamily('SBSansText')};

	.ant-badge-count {
		box-shadow: none;
	}

	${({ type }) => {
		switch (type) {
			case 'white':
				return BadgeWhite
			case 'primary':
				return BadgePrimary
			case 'danger':
				return BadgeDanger
			default:
		}
	}}
`
